module.exports = __webpack_public_path__ + "static/media/img4.a29d0d43.png";